<div class="order-history--container clickable font-5" role="link" (click)="navigateToOrder()">
    <div class="order-history--date">
        <label>Date</label>
        <span>{{ order.order_date | dateFormat: defaultShortDate }}</span>
    </div>
    <div  class="order-history--id">
        <label>Order #</label>
        <span>{{ order.id }}</span>
    </div>
    <div  class="order-history--state">
        <label>Status</label>
        <span class="font-weight-bold" [ngClass]="statusColorClass">{{ status }}</span>
    </div>
    <div  class="order-history--total">
        <label>Total</label>
        <span class="price font-weight-normal"><app-currency-price [price]="order.order_total" [currency]="order.currency" [solelySymbol]="true"></app-currency-price></span>
    </div>
</div>
